import {
  Button,
  Card,
  CardActions,
  CardContent,
  List,
  Divider,
  Modal,
  ListItem,
  ListItemText,
  ListItemIcon
} from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import CloseIcon from '@material-ui/icons/Close';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { connect } from 'react-redux';
import Alert from 'src/components/Alert';
import axios from 'src/utils/axios';
import { useHistory } from 'react-router';
import { useTranslation } from 'react-i18next';
import SendIcon from '@material-ui/icons/Send';

const useStyles = makeStyles(theme => ({
  root: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    outline: 'none',
    boxShadow: theme.shadows[20],
    width: 700,
    maxHeight: '100%',
    overflowY: 'auto',
    maxWidth: '100%'
  },
  actions: {
    justifyContent: 'flex-end'
  },
  submitButton: {
    marginTop: theme.spacing(2),
    width: '100%'
  }
}));
function CiktiSmsGonder({
  open,
  onClose,
  forceOpen,
  ReceiptNo,
  tasks,
  className,
  ciktiTip,
  ciktiTipTxt
}) {
  const classes = useStyles();
  const [LoadingControlCiktiSms, setLoadingControlCiktiSms] = useState(false);
  const [uyariAciklamaCiktiSms, setUyariAciklamaCiktiSms] = useState('');
  const [uyariCiktiSms, setUyariCiktiSms] = useState(false);
  const [uyariTipCiktiSms, setUyariTipCiktiSms] = useState();
  let AramaDataCiktiSms = [];
  const { t } = useTranslation('work_order');
  const history = useHistory();


  if (tasks.tasks !== '') {
    AramaDataCiktiSms = tasks.tasks.filter((d) => parseInt(d.ReceiptNo) === parseInt(ReceiptNo));
    console.log(AramaDataCiktiSms);
  }

  if (!open) {
    return null;
  }
  const handleFgsAramaYap = (event, Phone, tip, ReceiptNo, Consumer) => {
    setLoadingControlCiktiSms(true);
    const job = AramaDataCiktiSms[0];

    const requestData = {
      ReceiptNo: job.ReceiptNo,
      Type: tip,
      Gsm: Phone,
      EmployeeId: job.EmployeeId
    };

    const config = {
      headers: { 'Content-Type': 'application/json' }
    };

    axios.post('/InsertWorkOrderNotification', requestData, config)
      .then((response) => {
        setLoadingControlCiktiSms(false);
        setUyariTipCiktiSms('success');
        setUyariAciklamaCiktiSms(t('lblSuccess'));
        setUyariCiktiSms(true);
        forceOpen();
      }).catch((error) => {
        setLoadingControlCiktiSms(false);
        setUyariTipCiktiSms('error');
        setUyariAciklamaCiktiSms(`${error.response?.data?.error || ''}`);
        setUyariCiktiSms(true);
        forceOpen();
      });
  };


  const uyariKapatCiktiSms = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyariCiktiSms(false);
  };


  return (
    <Modal onClose={onClose} open={open}>
      <Card className={clsx(classes.root, className)}>
        <form>
          <CardContent>
            {LoadingControlCiktiSms ? (
              <CircularProgress
                status="loading"
                style={{ marginLeft: '50%' }}
              />
            ) : (
              ''
            )}
            <List component="nav" aria-label="main mailbox folders">

              {AramaDataCiktiSms[0].Phones.map(item => (
                <ListItem
                  button
                  onClick={event =>
                    handleFgsAramaYap(
                      event,
                      item.Phone,
                      1,
                      ReceiptNo,
                      ''
                    )}
                >
                  <ListItemIcon>
                    <SendIcon />
                  </ListItemIcon>
                  <ListItemText primary={item.PhoneType + ' : ' + item.Phone} />
                </ListItem>
              ))}
              <ListItem
                button
                onClick={event =>
                  handleFgsAramaYap(
                    event,
                    AramaDataCiktiSms[0]?.ContactPhone,
                    1,
                    ReceiptNo,
                    ''
                  )}
              >
                <ListItemIcon>
                  <SendIcon />
                </ListItemIcon>
                <ListItemText primary={t('lblContact') + ' : ' + AramaDataCiktiSms[0]?.ContactPhone} />
              </ListItem>
            </List>
            <div>
              {uyariCiktiSms ? (
                <Alert
                  onClose={uyariKapatCiktiSms}
                  open={uyariCiktiSms}
                  message={uyariAciklamaCiktiSms || ''}
                  variant={uyariTipCiktiSms}
                />
              ) : (
                <div />
              )}
            </div>
          </CardContent>
          <Divider />
          <CardActions className={classes.actions}>
            <Button
              variant="contained"
              color="primary"
              endIcon={<CloseIcon>Onizleme</CloseIcon>}
              onClick={onClose}
            >
              {t('lblClose')}
            </Button>
          </CardActions>
        </form>
      </Card>
    </Modal>
  );
}

CiktiSmsGonder.propTypes = {
  className: PropTypes.string,
  ReceiptNo: PropTypes.string,
  onClose: PropTypes.func,
  open: PropTypes.bool
};

CiktiSmsGonder.defaultProps = {
  open: false,
  onClose: () => { }
};

export default connect(state => ({ tasks: state.tasks1 }))(CiktiSmsGonder);
